const styles = {
    tooltipButtonStyle: {
        m: 0,
        p: 0,
    },
};

export default styles;
